/**
 * Converts Date object to string in dd-mm-yyyy format
 * @param date - Contains the date to be formatted
 * @param isMonthInAphabet - Flag value to format the month type
 * @returns - Returns the dd-mm-yy format as string
 */
export const getFormattedDate = (value: string, isMonthInAphabet: boolean): string => {
  const date = new Date(value);
  const monthType = (isMonthInAphabet) ? "long" : "2-digit";
  const day = date?.toLocaleString("default", { day: "2-digit" });
  const month = date?.toLocaleString("default", { month: monthType });
  const year = date?.toLocaleString("default", { year: "numeric" });
  return day + "-" + month + "-" + year;
};

/**
 * Get the current Time
 * @returns current hours, minutes and seconds
 */
export const getTime = (value: string): string => {
  return value?.split(" ")?.[1]?.split(".")?.[0];
};
